export default __webpack_public_path__ + "static/media/partyMixLollies.5e8801ce.jpeg";